module.exports = __webpack_public_path__ + "media/4x3/ni-7b131ab3.svg";